/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import BondDebtListByType from "./BondDebtListByType";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const FundsBondDebt = (props) => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [activeTab, setActiveTab] = useState('invoice');
  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_CLAIM_OBLIGATION');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_CLAIM_OBLIGATION");
      }
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/funds/bond-debt?tab=${value}`);
  };

  const tabList = [
    {
      label: "발행 내역 기준",
      action: _setActiveTab,
      value: 'issued',
    },
    {
      label: "거래명세서 기준",
      action: _setActiveTab,
      value: 'invoice',
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    !isEmpty(targetPermission) && (
      <>
        {tabList.map(({ value }, idx) => (
          <React.Fragment key={idx}>
            {value === activeTab ? <BondDebtListByType type={value} activeTab={activeTab} tabList={tabList} /> : <></>}
          </React.Fragment>
        ))}
      </>
    )
  );
};

export default FundsBondDebt;
